import { Reducer } from "react";
import { AuctionActions, AuctionActionEnum, IAuctionState } from ".";
import { IFilterItem } from "..";
import { dateUtcOnly, getAuctionTimezone } from "../../core";
import { product } from "../../features/Auction";
import { BidStatus, ExchangeTypeEnum } from "../../services";

const initialProductState = [
  { value: product.daily, isSelected: true } as IFilterItem,
  { value: product.term, isSelected: true } as IFilterItem,
  { value: product.intraday, isSelected: true } as IFilterItem,
  { value: product.weekly, isSelected: true } as IFilterItem,
  { value: product.weekend, isSelected: true } as IFilterItem,
];

const initialBidStatusState = [
  { value: BidStatus.Open, isSelected: true } as IFilterItem,
  {
    value: BidStatus.Closing,
    isSelected: true,
    color: "#33B1C3",
  } as IFilterItem,
  { value: BidStatus.Draft, isSelected: true, color: "yellow" } as IFilterItem,
  {
    value: BidStatus.Accepted,
    isSelected: true,
    color: "#7DBC55",
  } as IFilterItem,
  {
    value: BidStatus.Amended,
    isSelected: true,
    color: "#EF9F37",
  } as IFilterItem,
  {
    value: BidStatus.Rejected,
    isSelected: true,
    color: "#EB777A",
  } as IFilterItem,
  {
    value: BidStatus.Closed,
    isSelected: true,
    color: "#A275A2",
  } as IFilterItem,
];

const initialExchangeState = [
  { value: ExchangeTypeEnum.Jao.toUpperCase(), isSelected: true },
  { value: ExchangeTypeEnum.Empire.toUpperCase(), isSelected: true },
];

const initialDate = dateUtcOnly(new Date(), getAuctionTimezone());

export const initialState: IAuctionState = {
  loading: true,
  initialFilters: {
    startDateUtc: initialDate,
    products: initialProductState,
    bidStatus: initialBidStatusState,
    isShow: true,
    exchanges: initialExchangeState,
  },
  currentFilters: {
    startDateUtc: initialDate,
    products: initialProductState,
    bidStatus: initialBidStatusState,
    isShow: true,
    exchanges: initialExchangeState,
  },
};

export const auctionReducer: Reducer<IAuctionState, AuctionActions> = (
  state = initialState,
  action: AuctionActions
) => {
  switch (action.type) {
    case AuctionActionEnum.FetchFiltersAndAuctionData:
      return {
        ...state,
        loading: action?.state?.loading,
        initialFilters: {
          ...state.initialFilters,
          exchanges: action?.state?.initialFilters?.exchanges,
          corridorKeys: action?.state?.initialFilters?.corridorKeys,
          interconnectors: action?.state?.initialFilters?.interconnectors,
          corridors: action?.state?.initialFilters?.interconnectors,
        },
        currentFilters: {
          ...state.currentFilters,
          exchanges: action?.state?.initialFilters?.exchanges,
          corridorKeys: action?.state?.initialFilters?.corridorKeys,
          interconnectors: action?.state?.initialFilters?.interconnectors,
          corridors: action?.state?.initialFilters?.interconnectors,
        },
      };
    case AuctionActionEnum.FetchedFiltersAndAuctionDataSuccess:
      return {
        ...state,
        data: action.state?.data,
        loading: false,
        exceptionMessage: undefined,
        initialFilters: {
          ...state.initialFilters,
          corridorKeys: action?.state?.initialFilters?.corridorKeys,
          interconnectors: action?.state?.initialFilters?.interconnectors,
          corridors: action?.state?.initialFilters?.corridors,
          exchanges: action?.state?.initialFilters?.exchanges,
        },
        currentFilters: {
          ...state.currentFilters,
          corridorKeys: action?.state?.initialFilters?.corridorKeys,
          interconnectors: action?.state?.initialFilters?.interconnectors,
          corridors: action?.state?.initialFilters?.corridors,
          exchanges: action?.state?.initialFilters?.exchanges,
        },
      };
    case AuctionActionEnum.FetchedFiltersAndAuctionDataFailed: {
      return {
        ...state,
        loading: false,
        exceptionMessage: action.state?.exceptionMessage,
      };
    }
    case AuctionActionEnum.UpdateAuctionCorridorFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          corridors: action?.state?.currentFilters?.corridors,
        },
      };
    case AuctionActionEnum.UpateAuctionInterconnectorFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          interconnectors: action?.state?.currentFilters?.interconnectors,
        },
      };
    case AuctionActionEnum.UpateAuctionProductFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          products: action?.state?.currentFilters?.products,
        },
      };
    case AuctionActionEnum.UpateAuctionBidStatusFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          bidStatus: action?.state?.currentFilters?.bidStatus,
        },
      };

    case AuctionActionEnum.UpdateAuctionExchangeFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          exchanges: action?.state?.currentFilters?.exchanges,
        },
      };

    case AuctionActionEnum.UpateAuctionIsShowFilterValue:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          isShow: action?.state?.currentFilters?.isShow,
        },
      };
    case AuctionActionEnum.FetchAuctionDataOnlyAction:
      return {
        ...state,
        loading: true,
        currentFilters: {
          ...state.currentFilters,
          startDateUtc: action.state?.currentFilters?.startDateUtc,
        },
      };
    case AuctionActionEnum.FetchedAuctionDataOnlySuccess:
      return {
        ...state,
        data: action.state?.data,
        loading: false,
        exceptionMessage: undefined,
      };
    case AuctionActionEnum.FetchedAuctionDataOnlyFailed:
      return {
        ...state,
        loading: false,
        exceptionMessage: action.state?.exceptionMessage,
      };
    case AuctionActionEnum.UpdateAuctionWithBidResultAction:
      return {
        ...state,
        data: action.state?.data,
        loading: false,
      };
    case AuctionActionEnum.FetchAuctionDataOnlyWithoutDateAction:
    default:
      return { ...state };
  }
};
